<template>
  <ul class="menu__items" :class="{ 'menu__items--open': isOpenMenu }">
    <li>
      <button @click="$emit('trial-lesson')">
        <svg-icon name="training" class="menu__items-icon" />
        <span>Пробное обучение</span>
      </button>
    </li>
    <li>
      <Dropdown v-model="isOpenDropdownLangs">
        <button slot="reference" @click="isOpenDropdownLangs = true">
          <strong class="menu__items-icon menu__items-icon--text">{{
            langs[currentLang].label
          }}</strong>
          <span>{{ langs[currentLang].title }}</span>
          <svg-icon name="arrow-down" class="menu__items-arrow" />
        </button>
        <ul class="menu__items-langs">
          <li
            v-for="(lang, key) in langs"
            :key="key"
            :class="{ active: currentLang === key }"
            @click="currentLang = key"
          >
            {{ lang.title }}
          </li>
        </ul>
      </Dropdown>
    </li>
  </ul>
</template>

<script>
import Dropdown from '@/components/Common/Dropdown'

export default {
  name: 'MenuItems',
  components: { Dropdown },
  data: () => ({
    langs: {
      ru: {
        label: 'RUS',
        title: 'Русский'
      },
      en: {
        label: 'ENG',
        title: 'English'
      },
      sp: {
        label: 'SPA',
        title: 'Español'
      },
      ch: {
        label: 'CHI',
        title: '中文'
      }
    },

    isOpenDropdownLangs: false,

    currentLang: 'ru'
  }),

  props: {
    isOpenMenu: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.menu {
  &__items {
    width: 100%;
    padding-left: 12px;

    &-langs {
      font-weight: 500;
      font-size: 16px;
      line-height: 19px;

      li {
        color: $deepdark;
        cursor: pointer;
        transition: 0.3s;

        &:not(:first-of-type) {
          margin-top: 16px;
        }

        &.active,
        &:hover {
          color: $luchmara;
        }
      }
    }

    & > li {
      margin-top: 24px;
      font-weight: 500;
      font-size: 13px;

      button {
        color: $deepdark;
        display: flex;
        align-items: center;
        width: 100%;

        &:hover {
          opacity: 0.7;
          color: $luchmara;

          svg {
            &[stroke='#000'] {
              stroke: $luchmara;
              transition: inherit;
            }

            &[fill='#000'] {
              fill: $luchmara;
              transition: inherit;
            }
          }

          strong {
            color: $luchmara;
          }
        }

        span {
          opacity: 0;
          visibility: hidden;
          white-space: nowrap;
          flex: 1;
        }
      }
    }

    &-icon {
      width: 32px;
      height: 32px;
      background: $whisper;
      border-radius: 8px;
      flex-shrink: 0;
      transition: 0.3s;

      &--text {
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        font-size: 15px;
        color: $french-gray;
      }

      &[stroke='#000'] {
        stroke: $french-gray;
        transition: inherit;
      }

      &[fill='#000'] {
        fill: $french-gray;
        transition: inherit;
      }
    }

    &--open &-icon {
      margin-right: 8px;
    }

    &-arrow {
      opacity: 0;
      visibility: hidden;
      transition: 0.3s;
      stroke: $luchmara;
      width: 10px;
    }

    &--open &-arrow {
      opacity: 1;
      visibility: visible;
    }

    &--open {
      padding-left: 8px;

      button {
        justify-content: normal;

        span {
          opacity: 1 !important;
          visibility: visible !important;
          display: flex !important;
        }
      }
    }
  }
}
</style>
